export default function Help() {
  const helpTopics = [
    {
      icon: 'article',
      title: 'Documentation',
      description: 'Learn how to use ProofFlow with our comprehensive guides',
      link: '#'
    },
    {
      icon: 'video_library',
      title: 'Video Tutorials',
      description: 'Watch step-by-step tutorials to get started quickly',
      link: '#'
    },
    {
      icon: 'forum',
      title: 'Community Forum',
      description: 'Connect with other users and share best practices',
      link: '#'
    },
    {
      icon: 'support_agent',
      title: 'Contact Support',
      description: 'Get help from our support team',
      link: '#'
    }
  ]

  return (
    <div className="p-8 max-w-7xl mx-auto w-full">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-text-light dark:text-white mb-2">Help Center</h1>
        <p className="text-text-muted-light dark:text-text-muted-dark">
          Find answers and get support
        </p>
      </div>

      {/* Search */}
      <div className="mb-8">
        <div className="relative max-w-2xl">
          <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-text-muted-light dark:text-text-muted-dark">
            search
          </span>
          <input
            type="text"
            placeholder="Search for help..."
            className="w-full pl-12 pr-4 py-3 bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark rounded-xl text-text-light dark:text-white placeholder-text-muted-light dark:placeholder-text-muted-dark focus:outline-none focus:ring-2 focus:ring-primary transition-all"
          />
        </div>
      </div>

      {/* Help Topics */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {helpTopics.map((topic, index) => (
          <a
            key={index}
            href={topic.link}
            className="bg-surface-light dark:bg-surface-dark rounded-2xl shadow-soft border border-border-light dark:border-border-dark p-6 hover:border-primary/50 dark:hover:border-primary/50 transition-all group"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                <span className="material-symbols-outlined text-primary text-2xl">{topic.icon}</span>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-text-light dark:text-white mb-1 group-hover:text-primary transition-colors">
                  {topic.title}
                </h3>
                <p className="text-sm text-text-muted-light dark:text-text-muted-dark">
                  {topic.description}
                </p>
              </div>
              <span className="material-symbols-outlined text-text-muted-light dark:text-text-muted-dark group-hover:text-primary transition-colors">
                arrow_forward
              </span>
            </div>
          </a>
        ))}
      </div>

      {/* FAQ Section */}
      <div className="mt-12">
        <h2 className="text-xl font-bold text-text-light dark:text-white mb-6">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          <details className="group bg-surface-light dark:bg-surface-dark rounded-xl shadow-soft border border-border-light dark:border-border-dark hover:border-primary/30 transition-all">
            <summary className="flex items-center justify-between p-6 cursor-pointer">
              <span className="font-medium text-text-light dark:text-white">How do I create a new project?</span>
              <span className="material-symbols-outlined text-text-muted-light dark:text-text-muted-dark group-open:rotate-180 transition-transform">
                expand_more
              </span>
            </summary>
            <div className="px-6 pb-6 text-sm text-text-muted-light dark:text-text-muted-dark">
              Click on the "New Project" button in the dashboard or projects page, fill in the project details, and click "Create Project".
            </div>
          </details>

          <details className="group bg-surface-light dark:bg-surface-dark rounded-xl shadow-soft border border-border-light dark:border-border-dark hover:border-primary/30 transition-all">
            <summary className="flex items-center justify-between p-6 cursor-pointer">
              <span className="font-medium text-text-light dark:text-white">How do I invite team members?</span>
              <span className="material-symbols-outlined text-text-muted-light dark:text-text-muted-dark group-open:rotate-180 transition-transform">
                expand_more
              </span>
            </summary>
            <div className="px-6 pb-6 text-sm text-text-muted-light dark:text-text-muted-dark">
              Go to the Team page and click "Invite Member". Enter their email address and select their role, then send the invitation.
            </div>
          </details>

          <details className="group bg-surface-light dark:bg-surface-dark rounded-xl shadow-soft border border-border-light dark:border-border-dark hover:border-primary/30 transition-all">
            <summary className="flex items-center justify-between p-6 cursor-pointer">
              <span className="font-medium text-text-light dark:text-white">What are the subscription plans?</span>
              <span className="material-symbols-outlined text-text-muted-light dark:text-text-muted-dark group-open:rotate-180 transition-transform">
                expand_more
              </span>
            </summary>
            <div className="px-6 pb-6 text-sm text-text-muted-light dark:text-text-muted-dark">
              We offer Free, Pro, and Enterprise plans. Visit the Subscriptions page to see detailed pricing and features for each plan.
            </div>
          </details>
        </div>
      </div>
    </div>
  )
}
